import { call, put } from 'redux-saga/effects';
import { requestPermissions, requestVisibilityCheck } from '../requests/permission';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetPermissions(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestPermissions);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetVisibilityCheck(action) {
    try {
        const { target, userIds, permissions, callback } = action.payload;
        const response = yield call(requestVisibilityCheck, { target, userIds, permissions });
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}
